import merge from 'deepmerge';
export function isObject(obj) {
    return !!obj && typeof (obj) === 'object';
}
export function deepmerge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var objectArgs = args.filter(isObject);
    return merge.all(objectArgs, {
        arrayMerge: function (destinationArray, sourceArray) { return sourceArray; }
    });
}
export function provideAsArray(subject) {
    return (subject instanceof Array) ? subject : [subject];
}
export function unsignedArrayToBase64(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var res = [];
    var o1;
    var o2;
    var o3;
    var h1;
    var h2;
    var h3;
    var h4;
    var bits;
    var i = 0;
    if (!data) {
        return '';
    }
    do {
        o1 = data[i++];
        o2 = data[i++];
        o3 = data[i++];
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        res.push(b64.charAt(h1) + b64.charAt(h2) +
            b64.charAt(h3) + b64.charAt(h4));
    } while (i < data.length);
    var enc = res.join('');
    var r = data.length % 3;
    return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
}
export function toUrlBase64(strInBase64) {
    return strInBase64
        .replace(/=/g, '')
        .replace(/\//g, '_')
        .replace(/\+/g, '-');
}
//# sourceMappingURL=functions.js.map